import { utils } from '@ohif/core';

export function configureProduct(appConfig) {
  if (appConfig.routeProfile !== 'clinical') {
    throw new Error('The clinical build requires a clinical configuration');
  }
  appConfig.showStudyList = false;
}

export function getProductServices() {
  return [];
}

export function configureProductAuthentication(servicesManager) {
  const { userAuthenticationService } = servicesManager.services;
  utils.setApiAuthenticationProvider?.(userAuthenticationService);
  return userAuthenticationService;
}

export function isPatientReportBootstrap() {
  return false;
}

export function selectBootstrapExtensions({ modules }) {
  return modules;
}

export function selectBootstrapModes({ modules }) {
  return modules;
}

export function loadReportExtension(): never {
  throw new Error('Report bootstrap is unavailable in the clinical product');
}
